const ArrowDown: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="6" height="5" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M0.258295 1.75837L2.41663 3.91671C2.74163 4.24171 3.26663 4.24171 3.59163 3.91671L5.74996 1.75837C6.27496 1.23337 5.89996 0.333374 5.15829 0.333374H0.841628C0.0999614 0.333374 -0.266705 1.23337 0.258295 1.75837Z" fill="currentColor"/>
  </svg>
);

export default ArrowDown;
